var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryContact = function SvgDeliveryContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22 14.875a4.81 4.81 0 0 0-1.465-3.447A5.07 5.07 0 0 0 17 10a5.07 5.07 0 0 0-3.536 1.428A4.81 4.81 0 0 0 12 14.875v1.16h2.143L14.857 23h4.286l.714-6.964H22zM14 6a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.002,
    d: "M10.912 2.525C10.912 1.683 10.23 1 9.387 1H2.525C1.683 1 1 1.683 1 2.525v6.862c0 .843.683 1.525 1.525 1.525H8M5 7h2"
  })));
};
export default SvgDeliveryContact;